import React, { useContext } from 'react';
import { Translator } from 'ggApp/modules/translator';
import Tooltip from 'ggApp/shared/containers/tooltip';
import { CURRENCIES_ASSOCIATION } from 'ggApp/modules/store/constants';
import { formatPriceByLanguage } from 'ggApp/utils/money';
import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';

import { ThemeContext } from 'styled-components';

import {
    Wrap,
    LineWrap,
    HelpIcon,
    HelpIconWrap,
    SummaryWrap,
    SummaryText,
    Paragraph,
    ToolTipWrap,
} from './styled';

interface SummaryBlockProps {
    userDevice: string;
    activeStore: any;
    cart: any;
}

const SummaryBlock = ({ activeStore, cart }: SummaryBlockProps): JSX.Element => {
    const theme = useContext(ThemeContext);

    const format = (price: any): string =>
        !!price
            ? formatPriceByLanguage(
                  price,
                  CURRENCIES_ASSOCIATION[activeStore.default_currency],
                  activeStore.activeLanguage,
              )
            : `${CURRENCIES_ASSOCIATION[activeStore.default_currency]}0`;

    const { itemTotal, shipmentPrice, discountTotal, totalPrice } = cart;

    return (
        <Wrap>
            <LineWrap>
                <Paragraph>
                    <Translator tk="NEW_CHECKOUT_SUMMARY_ITEM_TOTAL" />
                </Paragraph>
                <Paragraph>{format(itemTotal)}</Paragraph>
            </LineWrap>

            <LineWrap>
                <Paragraph>
                    <Translator tk="NEW_CHECKOUT_SUMMARY_SHIPPING_TOTAL" />
                </Paragraph>

                <Paragraph>
                    {shipmentPrice ? (
                        format(shipmentPrice)
                    ) : (
                        <Translator tk="NEW_CHECKOUT_CART_OVERLAY_GROVER_CARE_COST" />
                    )}
                </Paragraph>
            </LineWrap>

            <LineWrap>
                <ToolTipWrap>
                    <Paragraph>
                        <Translator tk="NEW_CHECKOUT_CART_OVERLAY_GROVER_CARE" />
                    </Paragraph>

                    <Tooltip tooltipTK="NEW_CHECKOUT_CART_OVERLAY_GROVER_CARE_TOOLTIP" hideOnClick>
                        <HelpIconWrap>
                            <HelpIcon color={theme.colors['Level 5']} />
                        </HelpIconWrap>
                    </Tooltip>
                </ToolTipWrap>

                <Paragraph>
                    <Translator tk="NEW_CHECKOUT_CART_OVERLAY_GROVER_CARE_COST" />
                </Paragraph>
            </LineWrap>

            {!!discountTotal && (
                <LineWrap>
                    <Paragraph>
                        <Translator tk="NEW_CHECKOUT_SUMMARY_DISCOUNT" />
                    </Paragraph>
                    <Paragraph>-{format(discountTotal)}</Paragraph>
                </LineWrap>
            )}

            <SummaryWrap>
                <SummaryText>
                    <Translator tk="CHECKOUT_ORDER_TOTAL" />
                    <Translator tk="NEW_CHECKOUT_SUMMARY_TOTAL_VAT_SUFFIX" />
                </SummaryText>
                <SummaryText>{format(totalPrice)}</SummaryText>
            </SummaryWrap>
        </Wrap>
    );
};

export default withDeviceInfo(SummaryBlock);
